module.exports = __webpack_public_path__ + "img/reward-mug.ca3d3d0e.png";